import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import DivContainer from '../../components/DivContainer';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import {t} from 'i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ClientService from '../../services/ClientService';
import InputTextareaComponent from '../../components/inputs/InputTextareaComponent';
import {LinksComponent} from '../../components/inputs/LinksComponent';
import CountryService from '../../services/CountryService';
import {withRouter} from 'react-router-dom';
import {LocationAddressComponent} from '../../components/LocationAddressComponent';
import StringUtils from '../../utils/StringUtils';
import LocationUtil from '../../utils/LocationUtils';
import Constants from '../../utils/constants';
import {Card} from 'primereact/card';

class ClientContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new ClientService());
        this.state = {
            elementId: props.elementId,
            element: this.initNewElement(),
            statusOptions: [],
            viewMode: this.props.viewMode,
            countries: [],
            initLocationCountry: [],
            countryLocationLoaded: false,
        };
        this.countryService = new CountryService();
    }
    initNewElement() {
        return {
            name: '',
            firstName: '',
            nip: '',
            regon: '',
            status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            links: [],
            phoneNumber: '',
            contactPerson: '',
            note: '',
            address: {
                country: {},
                city: '',
                postalCode: '',
                streetName: '',
                streetNumber: '',
                houseNumber: '',
            },
        };
    }

    //overide
    renderPdfDownloadButton() {}
    getAddSucces() {
        const {t} = this.props;
        return t('client.addUserSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('client.updateUserSuccess');
    }

    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    initAfterSetElement() {
        super.initAfterSetElement();
        this.initLocationsCountry();
    }

    initBeforeSetElement() {
        this.enumService
            .getEnumList('ClientStatus')
            .then((statusOptions) => {
                statusOptions.forEach((o) => (o.label = t('ClientStatus.' + o.enumValue)));
                this.setState({
                    statusOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });

        this.countryService
            .getAll()
            .then((countries) => {
                this.setState({
                    countries,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy krajów');
            });
    }
    initLocationsCountry = () => {
        const location = this.state.element?.location;
        const isLatitudeNotFilled = StringUtils.isBlank(location?.latitude);
        if (this.props.viewMode === 'NEW' || isLatitudeNotFilled) {
            const {address} = this.state.element;
            const countryLocation = LocationUtil.getCountryLocationOrDefault(address?.country?.name);
            this.setLocation(countryLocation[0], countryLocation[1]);
        } else {
            this.setLocation(location.latitude, location.longitude);
        }
    };

    setLocation = (lat, lng) => {
        const isValidCoordinate = !StringUtils.isBlank(lat) && !StringUtils.isBlank(lng);
        this.setState({
            initLocationCountry: isValidCoordinate ? [lat, lng] : [],
            countryLocationLoaded: true,
        });
    };

    prepareFooterItems() {
        const {editUrl, elementId} = this.props;

        const result = super.prepareFooterItems();

        if (this.authService.isUserInAnyRole('ROLE_CLIENT_EDIT') && this.props.viewMode === 'VIEW') {
            result.push({
                id: 'edit-button',
                label: 'Edytuj',
                className: 'float-right',
                href: this.navigationContext.addNavigationContextToUrl(`${editUrl}/${elementId}`),
            });
        }

        return result;
    }

    renderDetails() {
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='clientName'
                        name='name'
                        label={t('client.details.clientName')}
                        colClass={this.props.viewMode === 'NEW' ? 'col-md-12' : 'col-md-10'}
                        value={this.state.element.name}
                        validator={this.validator}
                        validators='required|max:150'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputDropdownComponent
                        id='status'
                        name='status'
                        label={'Status'}
                        colClass='col-md-2'
                        value={this.state.element.status}
                        validator={this.validator}
                        options={this.state.statusOptions}
                        onChange={null}
                        viewMode={'VIEW'}
                        optionLabel='label'
                        dataKey='enumValue'
                        validators='not_required'
                        rendered={this.props.viewMode !== 'NEW'}
                        valueView={this.state.element.status ? this.state.element.status.label : ''}
                    />
                    <InputTextComponent
                        id='nip'
                        name='nip'
                        label={'NIP'}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.nip}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='regon'
                        name='regon'
                        label={'Regon'}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.regon}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='phoneNumber'
                        name='phoneNumber'
                        label={t('employee.details.phoneNumber')}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.phoneNumber}
                        validator={this.validator}
                        validators='not_required|phone|max:20'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='contactPerson'
                        name='contactPerson'
                        label={t('client.details.contactPerson')}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                        value={this.state.element.contactPerson}
                        validator={this.validator}
                        validators='not_required|max:20'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextareaComponent
                        id='note'
                        name='note'
                        label={'Notatka'}
                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'
                        value={this.state.element.note}
                        validator={this.validator}
                        validators='not_required|max:4096'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />

                    <LinksComponent
                        onLinksChange={(updatedLinks) => {
                            this.setState((prevState) => ({element: {...prevState.element, links: updatedLinks}}));
                        }}
                        links={this.state.element.links}
                        viewMode={this.props.viewMode}
                        validator={this.validator}
                    />

                    {this.state.countryLocationLoaded && (
                        <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper'>
                            <Card
                                header={() => {
                                    return (
                                        <div className='card-header-with-icon-container'>
                                            <i className='mdi mdi-compass-outline' />
                                            <span>{t('project.details.localization')}</span>
                                        </div>
                                    );
                                }}
                                className='data-card'
                            >
                                <LocationAddressComponent
                                    showErrorMessage={this.showErrorMessage}
                                    handleChangeAddress={(res, callback) => {
                                        this.setState(
                                            (prevState) => ({
                                                element: {
                                                    ...prevState.element,
                                                    address: {
                                                        city: res.city,
                                                        country: res.country,
                                                        streetNumber: res.streetNumber,
                                                        postalCode: res.postalCode,
                                                        streetName: res.streetName,
                                                    },
                                                },
                                            }),
                                            () => (callback ? callback() : null)
                                        );
                                    }}
                                    handleChangeLocation={(res) => {
                                        this.setState((prevState) => ({
                                            element: {
                                                ...prevState.element,
                                                location: {
                                                    latitude: res.length === 0 ? undefined : res[0].latitude,
                                                    longitude: res.length === 0 ? undefined : res[0].longitude,
                                                },
                                            },
                                        }));
                                    }}
                                    addressLocation={this.state.element}
                                    stateField='element.address'
                                    countries={this.state.countries}
                                    validator={this.validator}
                                    viewMode={this.props.viewMode}
                                    handleChange={this.handleChange}
                                    initCountryLocation={
                                        this.state.initLocationCountry?.length === 0
                                            ? Constants.POLAND_LOCATION
                                            : this.state.initLocationCountry
                                    }
                                />
                            </Card>
                        </div>
                    )}
                </DivContainer>
            </React.Fragment>
        );
    }
}
ClientContainer.defaultProps = {
    backUrl: '#/client-list',
    cancelUrl: '/#/client/details',
    editUrl: '/#/client/edit',
    viewUrl: '/#/client/details/',
    lazy: true,
};

ClientContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};
export default withRouter(withTranslation()(ClientContainer));
